import { convertDatesToISO, getHeaders } from '@/config/aux'
import { SensorGroupSensor } from '../models/sensorGroupSensor'
import { SensorGroupSensorStateType } from './state'
import axios from 'axios'

export interface SensorGroupSensorActionsType {
  getSensorGroupSensors(): Promise<void>
  getSensorGroupSensorsByGroupId(groupId: string): Promise<void>
  getSensorGroupSensorsBySensorId(sensorId: string): Promise<void>
  postSensorGroupSensor(sensorGroupSensor: SensorGroupSensor): Promise<void>
  putSensorGroupSensor(sensorGroupSensor: SensorGroupSensor): Promise<void>
  deleteSensorGroupSensor(id: string): Promise<void>
  updateSensorPositions(groupId: string, sensorPositions: { sensorId: string, position: number }[]): Promise<void>
}

export const SensorGroupSensorActions = {
  async getSensorGroupSensors(this: SensorGroupSensorStateType) {
    try {
      this.sensorGroupSensors = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-group-sensors`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorGroupSensor: SensorGroupSensor) => {
            this.sensorGroupSensors.push(sensorGroupSensor)
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorGroupSensors', error)
    }
  },
  async getSensorGroupSensorsByGroupId(this: SensorGroupSensorStateType, groupId: string) {
    try {
      this.sensorGroupSensors = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-group-sensors/group/${groupId}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorGroupSensor: SensorGroupSensor) => {
            this.sensorGroupSensors.push(sensorGroupSensor)
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorGroupSensors by groupId', error)
    }
  },
  async getSensorGroupSensorsBySensorId(this: SensorGroupSensorStateType, sensorId: string) {
    try {
      this.sensorGroupSensors = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-group-sensors/sensor/${sensorId}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorGroupSensor: SensorGroupSensor) => {
            this.sensorGroupSensors.push(sensorGroupSensor)
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorGroupSensors by sensorId', error)
    }
  },
  async postSensorGroupSensor(this: SensorGroupSensorStateType, sensorGroupSensor: SensorGroupSensor) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-group-sensors`
      const data = convertDatesToISO(sensorGroupSensor.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.sensorGroupSensors.push(sensorGroupSensor)
        }
      })
    } catch (error) {
      console.error('Error posting SensorGroupSensor', error)
    }
  },
  async putSensorGroupSensor(this: SensorGroupSensorStateType, sensorGroupSensor: SensorGroupSensor) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-group-sensors`
      const data = convertDatesToISO(sensorGroupSensor.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.sensorGroupSensors = this.sensorGroupSensors.map(sgs => (sgs.id === sensorGroupSensor.id ? sensorGroupSensor : sgs))
          }
        })
    } catch (error) {
      console.error('Error updating SensorGroupSensor', error)
    }
  },
  async deleteSensorGroupSensor(this: SensorGroupSensorStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-group-sensors/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.sensorGroupSensors = this.sensorGroupSensors.filter(sgs => sgs.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting SensorGroupSensor', error)
    }
  },
  async updateSensorPositions(this: SensorGroupSensorStateType, groupId: string, sensorPositions: { sensorId: string, position: number }[]) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-group-sensors/reorder/${groupId}`
      const data = { sensorPositions }

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            // Actualizar las posiciones en el store local
            // this.getSensorGroupSensorsByGroupId(groupId)
          }
        })
    } catch (error) {
      console.error('Error updating sensor positions', error)
    }
  },
}
